import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import ContactForm from './ContactForm';
import SimpleContactForm from './SimpleContactForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ContactFormWrapperProps {
    type: 'full' | 'simple';
    pageName: string;
    hideFields?: string[];
    redirectPath?: string;
    showHeader?: boolean;
}

const ContactFormWrapper: React.FC<ContactFormWrapperProps> = ({
    type,
    pageName,
    hideFields = [],
    showHeader = true,
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showConfirm, setShowConfirm] = useState(location.state?.formSuccess || false);

    const handleSuccess = () => {
        setShowConfirm(true);
        window.history.replaceState({}, document.title); // Ta bort state
    };

    return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
            {!showConfirm ? (
                <>
                    {showHeader && (
                        <>
                            <Typography variant="h5" gutterBottom sx={{ color: '#c6a04c' }}>
                                {t('contactform.title')}
                            </Typography>
                            <Typography variant="body1" paragraph>
                                {t('contactform.confirmText')}
                            </Typography>
                        </>
                    )}

                    {type === 'full' ? (
                        <ContactForm
                            pageName={pageName}
                            hideFields={hideFields}
                            onSuccess={handleSuccess}
                        />
                    ) : (
                        <SimpleContactForm onSuccess={handleSuccess} />
                    )}
                </>
            ) : (
                // ✅ Egen layout när formuläret är skickat
                <Box
                    sx={{
                        minHeight: '50vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        mt: { xs: 4, md: 8 },
                        px: 2,
                    }}
                >
                    <img
                        src="/images/senemail1.png"
                        alt="Bekräftelse"
                        style={{ width: '100px', maxWidth: '20vw', marginBottom: '20px' }}
                    />
                    <Typography variant="h5" gutterBottom sx={{ color: '#c6a04c' }}>
                        {t('contactform.thankYou')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#c6a04c', maxWidth: '500px', mb: 4 }}>
                        {t('contactform.confirmText')}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/')}
                        sx={{
                            backgroundColor: '#c6a04c',
                            color: '#000',
                            fontWeight: 'bold',
                            px: 4,
                            py: 1.5,
                            '&:hover': { backgroundColor: '#d1ae5a' }
                        }}
                    >
                        {t('buttons.backToHome')}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default ContactFormWrapper;
